var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#7E9A9C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11H18.6C17.1641 11 16 12.1641 16 13.6V34.4C16 35.8359 17.1641 37 18.6 37H29C30.4359 37 31.6 35.8359 31.6 34.4V13.6C31.6 12.1641 30.4359 11 29 11Z",
    stroke: "#7E9A9C",
    strokeWidth: 1.73333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8335 14.4666H20.7668C20.0488 14.4666 19.4668 15.0486 19.4668 15.7666V21.8332C19.4668 22.5512 20.0488 23.1332 20.7668 23.1332H26.8335C27.5514 23.1332 28.1335 22.5512 28.1335 21.8332V15.7666C28.1335 15.0486 27.5514 14.4666 26.8335 14.4666Z",
    stroke: "#7E9A9C",
    strokeWidth: 1.73333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2001 28.3333H20.3335C19.8548 28.3333 19.4668 27.9452 19.4668 27.4666C19.4668 26.9879 19.8548 26.5999 20.3335 26.5999H21.2001C21.6788 26.5999 22.0668 26.9879 22.0668 27.4666C22.0668 27.9452 21.6788 28.3333 21.2001 28.3333Z",
    stroke: "#7E9A9C",
    strokeWidth: 1.73333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2665 28.3333H26.3999C25.9212 28.3333 25.5332 27.9452 25.5332 27.4666C25.5332 26.9879 25.9212 26.5999 26.3999 26.5999H27.2665C27.7452 26.5999 28.1332 26.9879 28.1332 27.4666C28.1332 27.9452 27.7452 28.3333 27.2665 28.3333Z",
    stroke: "#7E9A9C",
    strokeWidth: 1.73333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.fc22fec0b756a13d0f86aca9b2b8238e.svg";
export { ForwardRef as ReactComponent };